import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/reports';
import * as reportPageActions from '../actions/reports';
import { Log } from 'ng2-logger';
import { ReportService } from '../../api/report-services';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';

const T = Translator.create();
const _logger = Log.create('report Saga');
const _reportService = new ReportService();

function* getDailyVisitors(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        const pageData = yield _reportService
            .RequestActiveUsers(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(reportPageActions.setDailyVisitorsAction(pageData, params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getStudentVisitors(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _reportService
            .RequestActiveUsers(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(
                reportPageActions.setStudentVisitorsAction(pageData, params.spinnerId, 'set')
            );
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getTotalVisitors(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _reportService
            .RequestTotalUsers(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(reportPageActions.setTotalVisitorsAction(pageData, params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getVirtualClassStats(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _reportService
            .RequestVirtualClassStats(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(
                reportPageActions.setVirtualClassStatsAction(pageData, params.spinnerId, 'set')
            );
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getActiveStudents(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _reportService
            .RequestActiveStudents(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(reportPageActions.setActiveStudentsAction(pageData, params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getFrequentlyVisitedCourses(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _reportService
            .RequestFrequentlyVisitedCourses(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }
        if (!isError) {
            yield put(reportPageActions.setFrequentlyVisitedCoursesAction(pageData, params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(pageData);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification('Graph' + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getRedirectToAlmsActivityAndExamReportUrl(params: any) : any {
    let isError = false;
    let errorList: any;

    const requestReturn = yield _reportService.GetRedirectToAlmsActivityAndExamReportUrl(params.urlReturnType, params.activityId, params.classId)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        })
        .then(response => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        
        if (isError) {
            yield put(coreActions.newNotification(T.t('r_api_gen_connecttoalms'), '', '', 'topRight', 'error', 0, params.spinnerId, 'set'));
        } else {
            window.open(requestReturn, '_blank');
        }
}

export function* watchDailyVisitorsData() {
    yield takeEvery(constants.actions.GET_DAILY_VISITORS, getDailyVisitors);
    return null;
}

export function* watchStudentVisitorsData() {
    yield takeEvery(constants.actions.GET_STUDENT_VISITORS, getStudentVisitors);
    return null;
}

export function* watchTotalVisitorsData() {
    yield takeEvery(constants.actions.GET_TOTAL_VISITORS, getTotalVisitors);
    return null;
}

export function* watchActiveStudentsData() {
    yield takeEvery(constants.actions.GET_ACTIVE_STUDENTS, getActiveStudents);
    return null;
}

export function* watchFrequentlyVisitedCoursesData() {
    yield takeEvery(constants.actions.GET_FREQUENTLY_VISITED_COURSES, getFrequentlyVisitedCourses);
    return null;
}

export function* watchVirtualClassStats() {
    yield takeEvery(constants.actions.GET_VIRTUAL_CLASS_VIEW_STATS, getVirtualClassStats);
    return null;
}

export function* watchGetRedirectToAlmsActivityAndExamReportUrl() {
    yield takeEvery(constants.actions.GET_REDIRECT_TO_ALMS_ACTIVITY_AND_EXAM_REPORT_URL, getRedirectToAlmsActivityAndExamReportUrl);
}

export function* ReportSagas() {
    yield all([
        watchDailyVisitorsData(),
        watchStudentVisitorsData(),
        watchActiveStudentsData(),
        watchTotalVisitorsData(),
        watchVirtualClassStats(),
        watchFrequentlyVisitedCoursesData(),
        watchGetRedirectToAlmsActivityAndExamReportUrl()
    ]);
}
